import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value[0] + value.slice(1).toLowerCase();
  }
}
